module.exports = __webpack_public_path__ + "static/img/pcInitNoData.bb8fe82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pubmedSearch/pcInitNoData.png
// module id = nzXt
// module chunks = 1